import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductComponentOtherProductMutation(
    $productComponentOtherProduct: ProductComponentOtherProductInput!
  ) {
    createProductComponentOtherProduct(
      input: { productComponentOtherProduct: $productComponentOtherProduct }
    ) {
      productComponentOtherProduct {
        id
      }
    }
  }
`;
